import {envIsLocal} from '../../config';

export function useIsOrgDashboardEnabled() {
  // todo(sammy): why envIsLocal vs !envIsPublicCloud? it's unclear when to use one or the other,
  // but this is probably sufficient.
  return {isOrgDashboardEnabled: envIsLocal};
}
